<div *ngIf="visible$ | async" class="product-variation-container">
  <ng-container
    *ngIf="'preferences.ChannelPreferences.EnableAdvancedVariationHandling' | ishServerSetting; else variationSelect"
  >
    <ish-product-variation-display />
    <ish-product-master-link />
  </ng-container>
  <ng-template #variationSelect>
    <ish-product-variation-select />
  </ng-template>
</div>
